import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CashSessionState,
  CashRegisterSession,
  CashOpeningDetail
} from "../../../types/cash/session";

const initialState: CashSessionState = {

  activeSession: null,
  history: [],
  loading: false,
  error: null,
  isCountingCash: false,

  openingForm: {
    registerId: null,
    openingAmount: 0,
    details: []
  }

};

const cashSessionSlice = createSlice({

  name: "cashSession",
  initialState,

  reducers: {

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setActiveSession(state, action: PayloadAction<CashRegisterSession | null>) {
      state.activeSession = action.payload;
    },

    setSessionHistory(state, action: PayloadAction<CashRegisterSession[]>) {
      state.history = action.payload;
    },

    clearSession(state) {
      state.activeSession = null;
    },

    /**
     * Activar hoja de conteo de efectivo
     */
    startCashCount(state) {
      state.isCountingCash = true;
    },

    /**
     * Ocultar hoja de conteo
     */
    stopCashCount(state) {
      state.isCountingCash = false;
    },

    /**
     * Alternar conteo
     */
    toggleCashCount(state) {
      state.isCountingCash = !state.isCountingCash;
    },

    /**
     * Seleccionar terminal POS
     */
    setOpeningRegister(state, action: PayloadAction<number | null>) {
      state.openingForm.registerId = action.payload;
    },

    /**
     * Actualizar monto contado
     */
    setOpeningAmount(state, action: PayloadAction<number>) {
      state.openingForm.openingAmount = action.payload;
    },

    /**
     * Actualizar detalles de denominaciones
     */
    setOpeningDetails(state, action: PayloadAction<CashOpeningDetail[]>) {
      state.openingForm.details = action.payload;
    },

    /**
     * Resetear formulario de apertura
     */
    resetOpeningForm(state) {

      state.openingForm = {
        registerId: null,
        openingAmount: 0,
        details: []
      };

      state.isCountingCash = false;

    }

  }

});

export const {
  setLoading,
  setError,
  setActiveSession,
  setSessionHistory,
  clearSession,

  startCashCount,
  stopCashCount,
  toggleCashCount,

  setOpeningRegister,
  setOpeningAmount,
  setOpeningDetails,
  resetOpeningForm

} = cashSessionSlice.actions;

export default cashSessionSlice.reducer;